import React, { useRef } from "react";
import { Button } from "primereact/button";
import ExternalVehicleTable from "./components/ExternalVehicleTable";
import ExternalVehicleForm from "./components/ExternalVehicleForm";
import GenericTableFilter from "../../components/common/GenericTableFilter";
import useExternalVehicleData from "./hooks/useExternalVehicleData";
import useExternalVehicleForm from "./hooks/useExternalVehicleForm";
import { useLanguage } from "../../contexts/LanguageContext";

const ExternalVehiclePage = () => {
  const { th } = useLanguage();

  const {
    // liste & durumlar
    rows,
    loading,
    totalCount,
    pagination,
    filters,
    // mutation durumları
    isCreating,
    isUpdating,
    isDeleting,
    // filtre meta / işlemler
    filterFields,
    customFilterTypes,
    customFilterOptions,
    handleDelete,
    saveVehicle,
    handleSearch,
    handleFilterChange,
    handleResetFilters,
    handleApplyFilters,
    onPageChange
  } = useExternalVehicleData();

  // form hook
  const formProps = useExternalVehicleForm(saveVehicle);

  const columnsRef = useRef(null);

  return (
    <div className="card">
      {(isCreating || isUpdating || isDeleting) && (
        <div className="card-overlay">
          <div className="loading-indicator">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }} />
          </div>
        </div>
      )}

      <div className="flex justify-content-between align-items-center mb-4">
        <h1 className="m-0">{th("externalVehicle.title")}</h1>
        <Button
          label={th("externalVehicle.new")}
          icon="pi pi-plus"
          onClick={formProps.handleAddNew}
        />
      </div>

      <ExternalVehicleForm {...formProps} />

      <div className="mb-2">
        <GenericTableFilter
          filterFields={filterFields}
          columns={columnsRef.current}
          customFilterTypes={customFilterTypes}
          customFilterOptions={customFilterOptions}
          handleSearch={handleSearch}
          onApplyFilters={handleApplyFilters}
          onResetFilters={handleResetFilters}
          handleFilterChange={handleFilterChange}
          hideLabels={true}
          textboxWidth="100%"
          filterFieldColClassName="col-12 md:col-8 lg:col-6"
        />
      </div>

      <ExternalVehicleTable
        rows={rows}
        loading={loading}
        totalCount={totalCount}
        pagination={pagination}
        onPageChange={onPageChange}
        filters={filters}
        handleEdit={formProps.handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default ExternalVehiclePage;

